import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import DebouncedInput from './DebouncedInput';

const Filter = ({column, table}) => {
  const firstValue = (table.getPreFilteredRowModel().flatRows[0])
    ? table.getPreFilteredRowModel().flatRows[0].getValue(column.id)
    : null;

  const columnFilterValue = column.getFilterValue();

  const sortedUniqueValues = useMemo(
    () =>
      typeof firstValue === 'number' || typeof firstValue === 'object'
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort(),
    [column.getFacetedUniqueValues()],
  );

  let minMax = column.getFacetedMinMaxValues();
  let min = minMax && minMax[0] ? Number(minMax[0]) : 0;
  let max = minMax && minMax[1] ? Number(minMax[1]) : 0;

  return typeof firstValue === 'number' ? (
    <div>
      <div className='flex space-x-2'>
        <DebouncedInput
          type='number'
          min={min}
          max={max}
          value={columnFilterValue ? columnFilterValue[0] : ''}
          onChange={(value) => (column.setFilterValue((old) => ([value, old ? old[1] : ''])))}
          placeholder={`Min ${min}`}
          className='w-24 border shadow rounded text-dark-gray'
          style={{width: '50%'}}
        />
        <DebouncedInput
          type='number'
          min={min}
          max={max}
          value={columnFilterValue ? columnFilterValue[1] : ''}
          onChange={(value) => (column.setFilterValue((old) => ([old ? old[0] : '', value])))}
          placeholder={`Max ${max}`}
          className='w-24 border shadow rounded text-dark-gray'
          style={{width: '50%'}}
        />
      </div>
      <div className='h-1' />
    </div>
  ) : (
    typeof firstValue === 'object' ? (
      <div></div>
    ) : (
      <div>
        <datalist id={`${column.id}list`}>
          {sortedUniqueValues.slice(0, 5000).map((value, i) => (
            <option value={value} key={i} />
          ))}
        </datalist>
        <DebouncedInput
          type='text'
          value={columnFilterValue ? columnFilterValue : ''}
          onChange={(value) => (column.setFilterValue(value))}
          placeholder={`Search... (${column.getFacetedUniqueValues().size})`}
          className='w-24 border shadow rounded text-dark-gray'
          list={`${column.id}list`}
          style={{width: '100%'}}
        />
        <div className='h-1' />
      </div>
    )
  );
};

Filter.propTypes = {
  column: PropTypes.object.isRequired,
  table: PropTypes.object.isRequired,
};

export default Filter;
